import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AdminLayout from './AdminLayout';
import './TicketDetails.css';

const TicketDetails = () => {
  const navigate = useNavigate();
  const { ticketId } = useParams();
  const [replyMessage, setReplyMessage] = useState('');

  // Placeholder ticket data
  const ticketData = {
    id: ticketId || 'TKT001',
    userName: 'John Doe',
    userEmail: 'john.doe@example.com',
    subject: 'Flight cancellation request',
    status: 'Open',
    priority: 'High',
    assignedAgent: 'Sarah Johnson',
    submittedDate: '2024-12-10 14:30',
    bookingId: 'SF12345678',
    userPhone: '+234 801 234 5678'
  };

  // Placeholder conversation messages
  const conversation = [
    {
      id: 1,
      sender: 'John Doe',
      senderType: 'user',
      timestamp: '2024-12-10 14:30',
      message: 'I need to cancel my flight booking SF12345678 due to an emergency. Can you please help me with the cancellation process?'
    },
    {
      id: 2,
      sender: 'Sarah Johnson',
      senderType: 'agent',
      timestamp: '2024-12-10 14:45',
      message: 'Hello John, I understand your situation. I can help you with the cancellation. Let me check your booking details first.'
    },
    {
      id: 3,
      sender: 'Sarah Johnson',
      senderType: 'agent',
      timestamp: '2024-12-10 15:00',
      message: 'I\'ve reviewed your booking. Since you have a refundable ticket, you\'re eligible for a full refund. Would you like me to proceed with the cancellation?'
    },
    {
      id: 4,
      sender: 'John Doe',
      senderType: 'user',
      timestamp: '2024-12-10 15:15',
      message: 'Yes, please proceed with the cancellation and refund. Thank you for your help.'
    }
  ];

  const handleChangeStatus = () => {
    // Placeholder
    console.log('Change status for ticket:', ticketData.id);
  };

  const handleAssignAgent = () => {
    // Placeholder
    console.log('Assign/reassign agent for ticket:', ticketData.id);
  };

  const handleCloseTicket = () => {
    // Placeholder
    console.log('Close ticket:', ticketData.id);
  };

  const handleSendReply = (e) => {
    e.preventDefault();
    if (replyMessage.trim()) {
      // Placeholder for send reply
      console.log('Sending reply:', replyMessage);
      setReplyMessage('');
    }
  };

  return (
    <AdminLayout pageTitle="Ticket Details">
      <div className="admin-ticket-details-page">
        {/* Page Title */}
        <div className="admin-ticket-details-header">
          <h1 className="admin-ticket-details-title">Ticket Details</h1>
          <nav className="admin-breadcrumb">
            <button 
              className="admin-breadcrumb-link"
              onClick={() => navigate('/admin/support-tickets')}
            >
              Support Tickets
            </button>
            <span className="admin-breadcrumb-separator">→</span>
            <span className="admin-breadcrumb-current">Ticket Details</span>
          </nav>
        </div>

        {/* Ticket Summary Card */}
        <div className="admin-ticket-summary-card">
          <div className="admin-ticket-summary-content">
            <div className="admin-ticket-summary-info">
              <div className="admin-ticket-summary-row">
                <div className="admin-ticket-summary-item">
                  <label className="admin-ticket-summary-label">Ticket ID</label>
                  <div className="admin-ticket-summary-value admin-ticket-id">{ticketData.id}</div>
                </div>
                <div className="admin-ticket-summary-item">
                  <label className="admin-ticket-summary-label">User</label>
                  <div className="admin-ticket-summary-value">
                    <div>{ticketData.userName}</div>
                    <div className="admin-ticket-summary-email">{ticketData.userEmail}</div>
                  </div>
                </div>
              </div>
              <div className="admin-ticket-summary-row">
                <div className="admin-ticket-summary-item">
                  <label className="admin-ticket-summary-label">Subject</label>
                  <div className="admin-ticket-summary-value admin-ticket-subject">{ticketData.subject}</div>
                </div>
              </div>
              <div className="admin-ticket-summary-row">
                <div className="admin-ticket-summary-item">
                  <label className="admin-ticket-summary-label">Status</label>
                  <div className="admin-ticket-summary-value">
                    <span className={`admin-status-badge admin-status-${ticketData.status.toLowerCase()}`}>
                      {ticketData.status}
                    </span>
                  </div>
                </div>
                <div className="admin-ticket-summary-item">
                  <label className="admin-ticket-summary-label">Priority</label>
                  <div className="admin-ticket-summary-value">
                    <span className={`admin-priority-badge admin-priority-${ticketData.priority.toLowerCase()}`}>
                      {ticketData.priority}
                    </span>
                  </div>
                </div>
              </div>
              <div className="admin-ticket-summary-row">
                <div className="admin-ticket-summary-item">
                  <label className="admin-ticket-summary-label">Assigned Agent</label>
                  <div className="admin-ticket-summary-value">{ticketData.assignedAgent}</div>
                </div>
                <div className="admin-ticket-summary-item">
                  <label className="admin-ticket-summary-label">Submitted Date</label>
                  <div className="admin-ticket-summary-value">{ticketData.submittedDate}</div>
                </div>
              </div>
            </div>
            <div className="admin-ticket-summary-actions">
              <button
                className="admin-summary-action-button"
                onClick={handleChangeStatus}
              >
                Change Status
              </button>
              <button
                className="admin-summary-action-button"
                onClick={handleAssignAgent}
              >
                {ticketData.assignedAgent === 'Unassigned' ? 'Assign Agent' : 'Reassign Agent'}
              </button>
              {ticketData.status !== 'Closed' && (
                <button
                  className="admin-summary-action-button"
                  onClick={handleCloseTicket}
                >
                  Close Ticket
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Main Content Grid */}
        <div className="admin-ticket-details-grid">
          {/* Conversation Card */}
          <div className="admin-ticket-conversation-card">
            <div className="admin-details-card-header">
              <h2 className="admin-details-card-title">Conversation</h2>
            </div>
            <div className="admin-details-card-content">
              <div className="admin-conversation-messages">
                {conversation.map((message) => (
                  <div 
                    key={message.id} 
                    className={`admin-message admin-message-${message.senderType}`}
                  >
                    <div className="admin-message-header">
                      <div className="admin-message-sender">{message.sender}</div>
                      <div className="admin-message-timestamp">{message.timestamp}</div>
                    </div>
                    <div className="admin-message-content">{message.message}</div>
                  </div>
                ))}
              </div>
              
              {/* Reply Form */}
              <form onSubmit={handleSendReply} className="admin-reply-form">
                <div className="admin-reply-input-wrapper">
                  <textarea
                    className="admin-reply-input"
                    placeholder="Type your reply..."
                    value={replyMessage}
                    onChange={(e) => setReplyMessage(e.target.value)}
                    rows={4}
                  />
                </div>
                <div className="admin-reply-actions">
                  <button
                    type="submit"
                    className="admin-reply-button"
                    disabled={!replyMessage.trim()}
                  >
                    Send Reply
                  </button>
                </div>
              </form>
            </div>
          </div>

          {/* Ticket Info Card */}
          <div className="admin-ticket-info-card">
            <div className="admin-details-card-header">
              <h2 className="admin-details-card-title">Ticket Information</h2>
            </div>
            <div className="admin-details-card-content">
              <div className="admin-details-field">
                <label className="admin-details-label">User Contact</label>
                <div className="admin-details-value">
                  <div>{ticketData.userName}</div>
                  <div className="admin-details-secondary">{ticketData.userEmail}</div>
                  <div className="admin-details-secondary">{ticketData.userPhone}</div>
                </div>
              </div>
              
              {ticketData.bookingId && (
                <div className="admin-details-field">
                  <label className="admin-details-label">Booking Reference</label>
                  <div className="admin-details-value admin-booking-reference">
                    {ticketData.bookingId}
                  </div>
                </div>
              )}

              <div className="admin-details-field">
                <label className="admin-details-label">Ticket Notes</label>
                <div className="admin-details-value">
                  <textarea
                    className="admin-notes-textarea"
                    placeholder="Add internal notes about this ticket..."
                    rows={4}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default TicketDetails;

